export default __webpack_public_path__ + "static/media/pokemon.8ae2ebe4.png";